import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EmotionsPrediction,
  GetEmotionsPredictionParams,
  GetEmotionsPredictionResponse
} from "./types";

export type NlpState = {
  emotionsPredictions: EmotionsPrediction | null;
  areEmotionsPreditionsLoading: boolean;
};

const initialState: NlpState = {
  emotionsPredictions: null,
  areEmotionsPreditionsLoading: false
};

const nlpSlice = createSlice({
  name: "nlp",
  initialState,
  reducers: {
    // Get Emotions Prediction
    getEmotionsPredictionRequest: (
      state,
      action: PayloadAction<GetEmotionsPredictionParams>
    ) => {
      state.areEmotionsPreditionsLoading = true;
    },
    getEmotionsPredictionSuccess: (
      state,
      action: PayloadAction<GetEmotionsPredictionResponse>
    ) => {
      state.emotionsPredictions = action.payload;
      state.areEmotionsPreditionsLoading = false;
    },
    getEmotionsPredictionFailure: (
      state,
      action: PayloadAction<{
        params: GetEmotionsPredictionParams;
        error: string;
      }>
    ) => {
      state.areEmotionsPreditionsLoading = false;
    },

    // Clear
    clear: () => initialState
  }
});

export const {
  getEmotionsPredictionRequest,
  getEmotionsPredictionSuccess,
  getEmotionsPredictionFailure,
  clear
} = nlpSlice.actions;

export const { actions: nlpActions } = nlpSlice;

export const reducer = nlpSlice.reducer;
